
import { defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { DispatcherTakesListOrderT } from '@/core/types/dispatcher.types'

// enums
import { DispatcherOrderStatusesEnum } from '@/core/enums/dispatcher.enums'

// composable
import useNotifications from '@/common/composable/useNotifications'
import {dispatcher} from "@/core/realisations/dispatcher.realisation";

export default defineComponent({
    components: {
        'the-button': TheButton,
        cheap: Cheap,
    },
    props: {
        item: {
            type: Object as PropType<DispatcherTakesListOrderT>,
            required: true,
        },
    },
    emits: ['item-removed'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_removing: false,
        })

        const remove = async () => {
            const answer = confirm(
                `Вы действительно хотите удалить забор заказа (id: ${props.item.id})?`
            )
            if (!answer) return

            try {
                state.is_removing = true

                await dispatcher.deleteTake(props.item.id)

                notifications.notify({
                    title: `Забор заказа (ID: ${props.item.id}) удален`,
                    type: 'success',
                })

                emit('item-removed')
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: `При удалении забора заказа ${props.item.id} произошла ошибка`,
                })
            } finally {
                state.is_removing = false
            }
        }

        return { DispatcherOrderStatusesEnum, state, remove }
    },
})
